import React, { useState, useEffect } from 'react';
import { Redirect, Route, useLocation } from 'react-router-dom';

import useAuth from '../auth/useAuth';
import { getError, isUndNullEmpNew, sendMessageNew, settings } from '../helpers/UtilsHelper';
import { ResponseClass } from '../classes/main/responseClass';

const { app, } = settings;
const { backend: appBackend, } = app;

const languageObj = { id: 'en', };

export default function PrivateRoute({ component: Component, ...rest }) {
    //#region variables
    const auth = useAuth();
    const location = useLocation();
    const [isUserLoged, setIsUserLoged] = useState(auth?.isLoged());
    //#endregion variables

    //#region methods
    const getData = () => {
        const currentMethod = 'getData';
        let response = new ResponseClass()?.getClass();
        try {
            if (isUndNullEmpNew({ data: auth?.account?.tokenVzLaML?.token, subMethod: currentMethod, })?.result) {
                setIsUserLoged(false);
            }
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: '' });
            sendMessageNew({
                msgType: response?.msgType,
                msgText: response?.msgText,
                timer: 0,
                confirmButton: true,
                timerProgressBar: false,
                languageId: languageObj?.id,
            });
        }
    }

    useEffect(() => {
        getData();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <Route {...rest}>
            {/* {auth?.isLoged() ? (<Component />) : (<Redirect to={{ pathname: '/login', state: { from: location, }, }} />)} */}
            {isUserLoged ? (<Component />) : (<Redirect to={{ pathname: appBackend?.urls?.login, state: { from: location?.pathname } }} />)}
        </Route>
    )
}